import { apiClient } from 'src/utils/api-client';
import type { ApiClient } from 'src/utils/api-client';
import { TrackingNewModel } from './models';

export function trackEventService(trackingNewModel: TrackingNewModel, client: ApiClient = apiClient) {
  return client.post<TrackingNewModel>('/tracking', trackingNewModel);
}
